import { OdinIcon, OdinIconSize } from '@myosh/odin-components';
import clsx from 'clsx';
import React from 'react';
import Avatar from '../../../assets/icons/avatar.svg';
import { isOfflineEnabled } from '../../../db/odin-db-util';
import { useOnlineStatus } from '../../../hooks/use-online-status';
import useProfileData from '../../../hooks/use-profile-data';
import { useAppSelector } from '../../../redux/hooks';
import { useGetUserAvatarQuery } from '../../../redux/services/user';
import { selectIsSyncing } from '../../../redux/slices/offline-sync-slice';

interface AvatarButtonProps {
  onClick: () => void;
}

const AvatarButton = React.forwardRef<HTMLButtonElement, AvatarButtonProps>(({ onClick }, ref) => {
  const { profileData: { user: userData } = {} } = useProfileData();

  const { data: userAvatar } = useGetUserAvatarQuery(userData?.id || 0, {
    skip: !userData?.id,
  });

  const isSyncing = useAppSelector(selectIsSyncing);
  const isOnline = useOnlineStatus();

  let title = '';
  if (isSyncing) {
    title = 'Syncing';
  } else {
    title = isOnline ? 'Online' : 'Offline';
  }

  return (
    <button ref={ref} onClick={onClick} className="settings-menu-button relative">
      <img src={userAvatar || Avatar} height={24} width={24} alt="profile image" className="rounded-full" />
      {isOfflineEnabled && (
        <span
          title={title}
          className={clsx(
            'absolute -bottom-1 -right-1 h-3 w-3 rounded-full border border-mono-1 transition-colors',
            isOnline ? 'bg-success' : 'bg-gray-2'
          )}
        >
          {isSyncing && <OdinIcon size={OdinIconSize.ExtraExtraSmall} icon="Loader" spin />}
        </span>
      )}
    </button>
  );
});

AvatarButton.displayName = 'AvatarButton';

export default React.memo(AvatarButton);
